module.exports = __webpack_public_path__ + "src/assets/img/empty-claims.30ea3477.png";